import React, { FC } from 'react';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import {
  AssistMigrationExecuteResult,
  AssistMigrationStepStatus,
} from 'types/assist/assistMigration';

const STEP_STATUS_COLOR: Record<AssistMigrationStepStatus, 'success' | 'default' | 'error'> = {
  success: 'success',
  skipped: 'default',
  failed: 'error',
};

const EXECUTE_STATUS_COLOR: Record<
  AssistMigrationExecuteResult['status'],
  'success' | 'warning' | 'error'
> = {
  completed: 'success',
  partial: 'warning',
  failed: 'error',
};

interface MigrationResultProps {
  result: AssistMigrationExecuteResult;
}

export const MigrationResult: FC<MigrationResultProps> = ({ result }) => (
  <div>
    <Chip
      label={`Migration ${result.status}`}
      color={EXECUTE_STATUS_COLOR[result.status]}
      style={{ marginBottom: 12 }}
    />
    {result.steps.map((step, index) => (
      <div
        key={`${step.type}-${index}`}
        style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}
      >
        <Chip size="small" label={step.status} color={STEP_STATUS_COLOR[step.status]} />
        <Typography variant="body2">
          {step.type}: {step.message}
        </Typography>
      </div>
    ))}
    {result.resultingProfile && (
      <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: 'block' }}>
        Resulting version: {result.resultingProfile.version}
      </Typography>
    )}
  </div>
);
